// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"_5deee560"};